/* Mounts the light/dark toggle into the header's icon row. The actual theme
   attribute is set earlier by an inline anti-flash script in theme.liquid;
   this file only needs to build the button and wire the click handler. */
(function () {
  var STORAGE_KEY = 'grind-theme';

  function setTheme(t) {
    document.documentElement.setAttribute('data-theme', t);
    try { localStorage.setItem(STORAGE_KEY, t); } catch (e) {}
    updateControls(t);
    var themeMeta = document.querySelector('meta[name="theme-color"]');
    if (themeMeta) themeMeta.setAttribute('content', t === 'light' ? '#fafafa' : '#080808');
    document.dispatchEvent(new CustomEvent('grind:theme-change', { detail: { theme: t } }));
  }

  function currentTheme() {
    return document.documentElement.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
  }

  function updateControls(theme) {
    document.querySelectorAll('[data-grind-theme-toggle], #grind-theme-toggle').forEach(function (btn) {
      var isLight = theme === 'light';
      btn.setAttribute('aria-pressed', String(isLight));
      btn.setAttribute('aria-label', isLight ? 'Switch to dark theme' : 'Switch to light theme');
      btn.setAttribute('title', isLight ? 'Switch to dark theme' : 'Switch to light theme');
    });
  }

  function mount() {
    if (document.getElementById('grind-theme-toggle')) return;
    var host = document.querySelector('.header__icons') || document.querySelector('.header-actions');
    if (!host) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = 'grind-theme-toggle';
    btn.className = 'g-toggle';
    btn.setAttribute('data-grind-theme-toggle', '');
    btn.innerHTML =
      '<span class="g-toggle__track"><span class="g-toggle__thumb">' +
      '<svg class="g-toggle__icon g-toggle__moon" viewBox="0 0 24 24" fill="none"><path d="M20 15.2A8.5 8.5 0 0 1 8.8 4c-.2 0-.4 0-.6 0a9 9 0 1 0 11.8 11.8Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<svg class="g-toggle__icon g-toggle__sun" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="4.25" stroke="currentColor" stroke-width="1.8"/><path d="M12 2.5V5.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M12 18.8v2.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M21.5 12h-2.7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M5.2 12H2.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M18.7 5.3l-1.9 1.9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M7.2 16.8l-1.9 1.9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M18.7 18.7l-1.9-1.9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M7.2 7.2L5.3 5.3" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
      '</span></span>';

    btn.addEventListener('click', function () {
      setTheme(currentTheme() === 'light' ? 'dark' : 'light');
    });

    host.insertBefore(btn, host.firstChild);
    updateControls(currentTheme());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }
})();
